import { motion } from "framer-motion";
import { Reveal, SectionLabel } from "../../lib/motion";
import { BUYER_ROADMAP } from "../../data";

export const BuyerRoadmap = () => {
  return (
    <section className="py-24 md:py-32 bg-warm-light/50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <Reveal className="max-w-2xl">
          <SectionLabel>Buyer Roadmap</SectionLabel>
          <h2 className="font-serif text-4xl md:text-5xl font-light text-navy mt-4 leading-tight">
            How to Purchase This Property
          </h2>
          <p className="mt-5 text-warm leading-relaxed">
            A straightforward five-step process from initial review to closing.
          </p>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {BUYER_ROADMAP.map((r, i) => (
            <motion.div
              key={r.step}
              data-testid={`roadmap-step-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.07, ease: [0.16, 1, 0.3, 1] }}
              className="relative bg-white border border-warm-border rounded-3xl p-8 transition duration-300 hover:-translate-y-1 hover:shadow-lg"
            >
              <div className="font-serif text-5xl text-water/25 leading-none">{r.step}</div>
              <h3 className="mt-4 font-semibold text-navy text-lg leading-snug">{r.title}</h3>
              <p className="mt-2 text-warm leading-relaxed text-sm">{r.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
